export { default } from 'pages/loyalty/loyalty-challenge-completed';
